<div 
  class="slide-text-widget animate__animated"
  [ngClass]="animationEnabled && !perWordAnimation && slideData?.animation"
  [class.animate-words]="animationEnabled && perWordAnimation"
  [style.animationDelay.ms]="slideData.animationDelay"
  [textMask]="slideData"
  [class.p-2]="slideData.enableBackground" 
  [style.background-color]="slideData.enableBackground ? slideData.backgroundColor : 'transparent'"
  [style.backdropFilter]="(slideData.enableBackground && slideData.backgroundBlur) ? ('blur(' + slideData.backgroundBlur + ')') : ''">
  <p 
    #wrapper 
    handleLinkClick
    class="my-0 ck-text"
    [textShadow]="slideData.textShadow"
    [padding]="slideData.spacing"
    [innerHTML]="contentConfig | slideContentHtml : wrapper | async">
  </p>
</div>
